import React from "react";
import { Link } from "react-scroll";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";

const QUICK_LINKS = [
  { to: "hero", label: "Home" },
  { to: "about", label: "About" },
  { to: "menu", label: "Menu" },
  { to: "gallery", label: "Gallery" },
  { to: "contact", label: "Contact" },
];

const SOCIAL_LINKS = [
  {
    icon: FaInstagram,
    href: "https://www.instagram.com/the_pahadi_bistro",
    label: "Instagram",
  },
  {
    icon: FaFacebookF,
    href: "https://www.facebook.com/people/The-Pahadi-Bistro/61560702225633/",
    label: "Facebook",
  },
  { icon: FaWhatsapp, href: "https://wa.me/919373309484", label: "WhatsApp" },
];

export default function Footer() {
  return (
    <footer className="bg-charcoal text-cream/80">
      <div className="max-w-7xl mx-auto px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <img
                src="/assets/PHBLogo.png"
                alt="PHB Logo"
                className="h-10 w-10 object-contain"
              />
              <h3 className="font-display text-2xl font-bold text-cream">
                The Pahadi Bistro
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-cream/60 max-w-xs">
              Authentic Nepali &amp; Indo-Chinese flavours with pahadi-style
              comfort food. Made with love in Kharadi, Pune.
            </p>
            <div className="flex gap-3 mt-5">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-redAccent transition-colors duration-200"
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-cream text-sm uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    smooth
                    duration={600}
                    offset={-70}
                    className="text-sm text-cream/60 hover:text-gold transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-cream text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-2.5 text-sm text-cream/60">
              <p>
                The Pahadi Bistro <br />
                Shop No.2, Global Highstreet
                <br />
                Kharadi, Pune 411014
              </p>
              <p>
                <a
                  href="tel:+919373309484"
                  className="hover:text-gold transition-colors"
                >
                  +91 93733 09484
                </a>
              </p>
              <p>
                <a
                  href="mailto:thepahadibistro@gmail.com"
                  className="hover:text-gold transition-colors"
                >
                  thepahadibistro@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-cream/40">
            &copy; {new Date().getFullYear()} The Pahadi Bistro. All rights
            reserved.
          </p>
          <p className="text-xs text-cream/40">
            Born in the hills, served with soul
          </p>
        </div>
      </div>
    </footer>
  );
}
